// src/features/messages/panels/AboutChatPanel.tsx
//
// 1.24.00: the decorative "Mute notifications" switch that used to sit here is
// GONE, not hinted. TruXSocial is mute-only at the ACCOUNT level (see
// PostMoreMenu's Mute/Unmute) and there is no per-thread mute concept in the
// product — so even a DisabledHint would have been promising a feature that
// will never arrive. Removing it is the honest fix; panels.test.tsx pins its
// absence so it cannot creep back.
import styled from 'styled-components';
import { Panel, SectionLabel, Avatar, MetaRow } from '@/ui';
import type { Conversation } from '@/core/models/message';

const Identity = styled.div`display: flex; flex-direction: column; align-items: center; gap: 6px; text-align: center;`;
const Name = styled.span`
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: 700; color: ${({ theme }) => theme.color.textPrimary};
`;
const Sub = styled.span`
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;
export interface AboutChatPanelProps {
  convo: Conversation;
}

export function AboutChatPanel({ convo }: AboutChatPanelProps) {
  const memberCount = convo.members ?? 0;
  const pendingCount = convo.pendingInvites?.length ?? 0;
  // `online === null` means the other side hid their activity status — say
  // nothing rather than claiming they are offline (same rule as the thread
  // header; see ConversationThread).
  const presence = convo.online === null ? null : convo.online ? 'Online' : 'Offline';
  const sub =
    convo.type === 'group'
      ? `${memberCount} ${memberCount === 1 ? 'member' : 'members'}`
      : presence;
  const invited = convo.type === 'group' && pendingCount > 0 ? `${pendingCount} invited` : '';
  return (
    <Panel>
      <SectionLabel as="h2">About this chat</SectionLabel>
      <Identity>
        <Avatar name={convo.name} size={64} />
        <Name>{convo.name}</Name>
        <Sub>
          <MetaRow>
            {convo.type === 'group' ? 'Group' : 'Direct message'}
            {sub}
            {invited}
          </MetaRow>
        </Sub>
      </Identity>
    </Panel>
  );
}
